import { useContext, useEffect, useState } from 'react'
import ActiveSurveyModal from './active-survey-modal'
import { useTranslation } from 'react-i18next'
import { findNivel } from '@BUP/services/BraveUp'
import { LocationContext } from '@BUP/contexts/LocationContext'
import BupSpinner from '@BUP/components/Loading/Spinner'
import ViewResourcesButton from './ViewResourcesButton'
import { useSendActivationSurvey } from '@BUP/hooks/Sociogram/useSendActivationSurvey'
import { useSociogramActions } from '@BUP/hooks/Sociogram/useSociogramContext'
import FinishSurveyModal from './finish-survey-modal'
import ResultsButton from './results-button'
import styles from './inner-table.module.scss'

const ActionsCell = ({ survey, isMultiCourse, sociogram, errorResultRecommendations, participantsTerminated }) => {
  const i18n = useTranslation()
  const locale = useContext(LocationContext)
  const lang = locale && locale.locale
  const { setSelectedSurvey, setDataResponseActiveSurvey } = useSociogramActions()
  const [stateSurveyModal, setStateSurveyModal] = useState(false)
  const {
    updateSurveySociogram,
    isLoading: loadingResponseSurvey,
    dataResponseSurvey
  } = useSendActivationSurvey(survey, sociogram.id)

  useEffect(() => {
    if (dataResponseSurvey) {
      setStateSurveyModal(false)
      setDataResponseActiveSurvey(dataResponseSurvey)
    }
  }, [dataResponseSurvey, setDataResponseActiveSurvey])

  const { isActive, isDone, resource, courses } = survey

  if (!courses || courses.length === 0) {
    return (
      <div className={styles.actions_cell_wrapper}>
        <span className={styles.actions_cell_text}>{i18n.t('pages.data.sociogram.activeSociogramEce.noCoursesMessage')}</span>
      </div>
    )
  }

  const course = courses[0]
  const nivel = lang ? findNivel(lang, course) : null
  const splitNivel = nivel && nivel.id.split(':')[1]
  const surveyName = isMultiCourse ? i18n.t(`common.resources.course.values.tags.nivel.${splitNivel}`) : course.name

  const handleShowSurveyModal = (survey) => {
    setStateSurveyModal(true)
    setSelectedSurvey(survey)
  }

  const handleCloseSurveyModal = () => {
    setSelectedSurvey(null)
    setStateSurveyModal(false)
  }

  const handleConfirmSurvey = async (data, action) => {
    await updateSurveySociogram({
      data, action
    })
  }

  if (loadingResponseSurvey) {
    return <BupSpinner size='small' />
  }

  const surveyIsNotActivated = !isActive && !isDone
  const surveyIsActivated = isActive && !isDone
  const surveyIsDone = !isActive && isDone

  if (surveyIsNotActivated) {
    return (
      <div
        className={styles.actions_cell_wrapper}
        data-test='cell-wrapper-active-button'
      >
        <ActiveSurveyModal
          sociogram={sociogram}
          survey={survey}
          handleShowSurveyModal={handleShowSurveyModal}
          handleCloseSurveyModal={handleCloseSurveyModal}
          stateSurveyModal={stateSurveyModal}
          handleConfirmSurvey={handleConfirmSurvey}
          loadingResponseSurvey={loadingResponseSurvey}
          surveyName={surveyName}
        />
      </div>
    )
  }

  if (surveyIsActivated) {
    return (
      <FinishSurveyModal
        survey={survey}
        handleShowSurveyModal={handleShowSurveyModal}
        stateSurveyModal={stateSurveyModal}
        handleCloseSurveyModal={handleCloseSurveyModal}
        handleConfirmSurvey={handleConfirmSurvey}
        loadingResponseSurvey={loadingResponseSurvey}
        surveyName={surveyName}
      />
    )
  }

  if (surveyIsDone) {
    return (
      <div
        className={styles.actions_cell_wrapper}
        data-test='cell-wrapper-simple-results-button'
      >
        <ResultsButton
          isMultiCourse={isMultiCourse}
          survey={survey}
          surveyName={surveyName}
          participantsTerminated={participantsTerminated}
        />
        {!isMultiCourse && (
          <div className={styles.resources_button_wrapper}>
            <ViewResourcesButton
              buttonText={`${i18n.t('pages.data.sociogram.activeSociogramEce.table.resourcesButton')}`}
              resource={resource}
              errorResultRecommendations={errorResultRecommendations}
              surveyName={surveyName}
            />
          </div>
        )}
      </div>
    )
  }
}

export default ActionsCell
